import { Component, OnInit, Input } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { File } from '@core/objects';
import { NotificationInterface } from '@core/store/models/notifications.interface';
import { FilesService }   from '@core/services/files/files.service';
import { NotificationsService } from '@core/services/notifications/notifications.service';
import { UrlService } from '@core/services/url/url.service';

@Component({
    selector: 'core-notifications-helpers-action-file-annotations-start',
    templateUrl: './file-with-annotations-start.component.html',
    styleUrls: ['./file-with-annotations-start.component.scss']
})
export class CoreNotificationsHelpersActionFileAnnotationsStartComponent implements OnInit {

    @Input() notification: NotificationInterface;

    constructor(private notsSrv: NotificationsService, 
        private filesSrv: FilesService,
        private urlSrv: UrlService) {
    }

    ngOnInit(){
        if(this.notification.data.details?.url && this.notification.data.details?.file){
            this.filesSrv.getDownloadPdfAnnotationsFile(this.notification.data.details.file, this.notification.data.details.url)
            .subscribe({
                next: (pdf: File) => { // only with id in this case
                    // console.debug(" %%%%% RESPONSEEEEEEEEEEEEEE ====> ",pdf)
                    if(pdf != null && pdf?.id){
                        const fileId = pdf.id;

                        window.location.href = this.urlSrv.build('/files/'+fileId);
                        this.dismiss();
                    } 
                    else{
                        // TODO set the "other case" that shoult not happened because is controlled on the service
                    }
                },
                error: (err: HttpErrorResponse) => {
                    // TODO: Handle error maybe send a notification error. Already done in the service.
                    console.debug(" download pdf with annotations error ",err);
                    this.dismiss();
                }
            });
        
        }
        
    }

    dismiss():void {
        this.notsSrv.dismissNotification(this.notification.id);
    }


}
